
const apiServer = "https://drama-town-api.hcdhwh.com/";
export const  baseServerUrl = process.env.NODE_ENV === 'production' ? '$PROTOCOL://$BASE_SERVER' : apiServer

//会员注册
// http://192.168.2.58:976/ wang

// http://192.168.2.64:976/ liu

// http://192.168.2.65:976/ qiu

// http://192.168.2.53:976/ xiao

// http://192.168.2.66:976/ lin

// https://drama-town-api.shuandigital.cn/

// https://drama-town-api.hcdhwh.com/  正式



// WEBPACK FOOTER //
// ./src/config/index.js